export default "__VITE_ASSET__815da45f__"